module.exports = __webpack_public_path__ + "media/images/Ellipse 118-e95441db1bf55bf545cc28876a299ec6.svg";